import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Question } from 'src/app/models';
import { ContentService } from 'src/app/services/content/content.service';
import { AccordionComponent, CenterSectionComponent } from 'src/app/shared/components';
import { environment } from 'src/environments/environment';
import { ContentSection } from '../../../shared/layout/content-section';
import { SanitizeHtmlPipe } from '../../../shared/pipes/sanitize-html.pipe';

@Component({
  selector: 'app-questions-and-answers',
  templateUrl: './questions-and-answers.component.html',
  styleUrls: ['./questions-and-answers.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CenterSectionComponent, SanitizeHtmlPipe, AccordionComponent],
})
export class QuestionsAndAnswersComponent extends ContentSection implements OnInit {
  private router = inject(Router);

  contentUrl = environment.cmsOrigin;
  pageNotFoundUrl = environment.urls.page_not_found;

  bannerImage: string;
  title: string;
  description: string;
  questions: Question[] = [];

  constructor() {
    const contentService = inject(ContentService);
    super(contentService, 'questionsAndAnswers', { meta: true });

    if (!this.contentService.has('questionsAndAnswers')) {
      this.router.navigate([this.pageNotFoundUrl]);
      return;
    }
  }

  ngOnInit() {
    const bannerImage = this.content.get('bannerImage');
    if (bannerImage) {
      this.bannerImage = `${this.contentUrl}/${bannerImage}`;
    }
    this.title = this.content.get('titleText');
    this.description = this.contentService.addImageSource(this.content.get('descriptionText'));

    const questionsAndAnswers = this.content.get('questionsAndAnswersContent');
    if (questionsAndAnswers) {
      this.questions = questionsAndAnswers as Question[];
    }
  }

  imageError() {
    this.bannerImage = '';
  }
}
